module.exports = __webpack_public_path__ + "img/default.ffecda72.png";